// extracted by mini-css-extract-plugin
module.exports = {"iconWrap":"style_iconWrap__lHmn6","hotkey":"style_hotkey__bmjhc","iconAndLabel":"style_iconAndLabel__8A5_7","iconAndHotkeyWrap":"style_iconAndHotkeyWrap__D9MOk"};